/************************************************************************************************************
Author                          : Trizent Technologies Private Limited
Date                            : 
Notes/Remarks                   : 

Organization:  	Trizent Technologies Private Limited.
		Module No. 17, SBC, Thejaswini Building
		Phase 1, Technopark, Thiruvananthapuram - 695581, 
		Kerala, India
 
Copyright 2026 (C) Trizent Technologies Pvt Ltd. (www.trizentinc.com)
All rights reserved.
***************************************************************************************************************/

import React, { useState } from 'react'
import HeaderSection from '../../../../common/headerSection'
import PageHeader from '../../../../common/pageHeader'
import ViewSchedule from './viewSchedule'
import { useTranslation } from 'react-i18next'

const ScheduleCalendar = () => {

    const { t } = useTranslation();
    const [showViewSchedule, setShowViewSchedule] = useState("1");

  return (
    <div>
        <HeaderSection />
        <PageHeader pageHeader={t("scheduleProduction.productionCalendar")} pageDescription={t('pageDescription.productionCalendar.description')} />

        <div className="m-3">
              <ViewSchedule setTab={setShowViewSchedule} />
            </div>
    </div>
  )
}

export default ScheduleCalendar